import { useCallback, useEffect, useState } from 'react';

/**
 * Hook für Browser-Fullscreen-API.
 * Gibt isFullscreen-State und toggle()-Funktion zurück.
 * Nützlich für MDE-Ansichten auf Handscannern, um den kompletten
 * Bildschirm für die App zu nutzen (ohne URL-Bar / Tabs).
 */
export function useFullscreenToggle() {
  const [isFullscreen, setIsFullscreen] = useState<boolean>(
    typeof document !== 'undefined' && !!document.fullscreenElement
  );

  useEffect(() => {
    const onChange = () => setIsFullscreen(!!document.fullscreenElement);
    document.addEventListener('fullscreenchange', onChange);
    return () => document.removeEventListener('fullscreenchange', onChange);
  }, []);

  const toggle = useCallback(() => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch(() => {});
    } else {
      document.exitFullscreen().catch(() => {});
    }
  }, []);

  return { isFullscreen, toggle };
}
